import { Toast, ToastBody, ToastTitle } from '@fluentui/react-components';
import { CheckmarkCircle20Filled, DismissCircle20Filled, Info20Filled, Warning20Filled } from '@fluentui/react-icons';

import './AppToast.Styles.css';

export type AppToastIntent = 'success' | 'error' | 'warning' | 'info';

interface AppToastProps {
    intent: AppToastIntent;
    title: string;
    body?: string | null;
    /** Lista de detalles (por ejemplo, los errores de validación del servidor). */
    items?: string[] | null;
}

const ICONS: Record<AppToastIntent, JSX.Element> = {
    success: <CheckmarkCircle20Filled />,
    error: <DismissCircle20Filled />,
    warning: <Warning20Filled />,
    info: <Info20Filled />
};

/**
 * Aviso flotante con la jerarquía de los banners de la guía: franja de color
 * a la izquierda, ícono del intento, título en bold y detalle debajo. Se pasa
 * a `dispatchToast` en lugar de armar el `Toast` a mano en cada pantalla.
 */
export const AppToast = ({ intent, title, body, items }: AppToastProps) => (
    <Toast className={`app-toast app-toast--${intent}`}>
        <ToastTitle media={<span className="app-toast__icon" aria-hidden>{ICONS[intent]}</span>}>
            <span className="app-toast__title">{title}</span>
        </ToastTitle>
        {(body || (items && items.length > 0)) && (
            <ToastBody>
                <span className="app-toast__body">
                    {body}
                    {items && items.length > 0 && (
                        <ul className="app-toast__list">
                            {items.map((item) => <li key={item}>{item}</li>)}
                        </ul>
                    )}
                </span>
            </ToastBody>
        )}
    </Toast>
);

/** Duración según el peso del mensaje: el éxito se va solo, el error espera a que lo lean. */
export const toastTimeout = (intent: AppToastIntent): number => (intent === 'success' ? 3500 : 7000);
